export { EmbeddedFaqItem } from './EmbeddedFaqItem';
export type {
  EmbeddedFaqItemProps,
  EmbeddedFaqItemHeadingLevel,
} from './EmbeddedFaqItem';
